import {DatePipe, NgForOf, NgIf, NgOptimizedImage} from '@angular/common';
import {Component, OnInit, TemplateRef} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from '@angular/material/expansion';
import {MatTab, MatTabContent, MatTabGroup, MatTabLabel} from '@angular/material/tabs';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {LucideAngularModule} from 'lucide-angular';
import {ComponentsModule} from '../../../components/components.module';
import {NavigationTableRequestModel, NavigationTableResponseItemModel, PaginationModel} from '../../../models/file-table.model';
import {CargoModel, PartiesModel, PublicProductModel} from '../../../models/products.model';
import {HelpersService} from '../../../services/helpers.service';
import {MemberService} from '../../../services/member.service';
import {ModalService} from '../../../services/modal/modal.service';
import {AlertService} from '../../../services/notify/alert.service';
import {ProductionService} from '../../../services/production.service';
import {DocumentsServiceService} from '../../documents/documents-service.service';

@Component({
    selector: 'app-public-detail-card',
    standalone: true,
    imports: [
        ComponentsModule,
        LucideAngularModule,
        MatAccordion,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        MatTab,
        MatTabContent,
        MatTabGroup,
        MatTabLabel,
        NgForOf,
        NgIf,
        DatePipe,
        NgOptimizedImage,
        MatButton
    ],
    templateUrl: './public-detail-card.component.html',
    styleUrl: './public-detail-card.component.scss'
})
export class PublicDetailCardComponent implements OnInit {
    puid: string;
    publicPuid: string;
    publicCard: PublicProductModel;

    previews: any[] = [];

    selectedProductCardPhotos: File[] = [];

    batchCounterValue: any = 0;
    price: string = null;
    allBatches: PartiesModel[] = [];
    allCargos: CargoModel[] = [];

    collectionId: number = null;
    documentKey: string = null;

    constructor(
        private activeRouter: ActivatedRoute,
        private productionService: ProductionService,
        private alertService: AlertService,
        private memberService: MemberService,
        protected controller: DocumentsServiceService,
        public helpers: HelpersService,
        public modalService: ModalService,
        public router: Router,
    ) {
    }

    ngOnInit() {
        this.activeRouter.params.subscribe(params => {
            this.puid = params.puid;
            this.publicPuid = params.publicPuid;
            this.getCard();
        });
    }

    getCard(): void {
        this.productionService.getPublicProductCard(this.puid, this.publicPuid).subscribe({
            next: res => {
                this.publicCard = res.product_public;
                this.getPhotos();
                this.getBatches();

                this.memberService.getMemberGuid(this.publicCard.original.creator_guid).subscribe({
                    next: res => {
                        this.publicCard.original.author = res;
                    }
                });
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    getPhotos(): void {
        // this.publicCard.photos.forEach(image => {
        //     this.productionService.getPhotoInProductCard(this.publicPuid, image.ukey).subscribe({
        //         next: res => {
        //             image.originImage = res;
        //         },
        //         error: err => {
        //             this.alertService.setAlert(err.message.info, 'blue');
        //         }
        //     });
        // });
    }

    getBatches(): void {
        this.productionService.getAllBatchesPublicCard(this.puid).subscribe({
            next: res => {
                console.log(res);
                this.allBatches = res.parties;
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    addBatchToNewCargo(): void {
        this.productionService.createCargo().subscribe({
            next: res => {
                const data = {
                    product_public_puid: this.publicPuid,
                    counter_type: 'int',
                    count: Number(this.batchCounterValue),
                    price: Number(this.price),
                };
                this.productionService.addBatchToCargo(res.cargo.ps_cargo_key, data).subscribe({
                    next: res => {
                        console.log(res);
                    }, error: err => {
                        this.alertService.setAlert(err.message, 'blue');
                    }
                });
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    openCargoModal(modal: TemplateRef<any>): void {
        this.productionService.getAllCargos().subscribe({
            next: res => {
                this.allCargos = res.cargos;

                this.modalService.openTemplateModal(modal);
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    addBatchToExistCargo(cargoKey: string, modal: NgbModalRef): void {
        const data = {
            product_public_puid: this.publicPuid,
            counter_type: 'int',
            count: Number(this.batchCounterValue),
            price: Number(this.price),
        };

        this.productionService.addBatchToCargo(cargoKey, data).subscribe({
            next: res => {
                modal.close();
                console.log(res);
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    //TODO другой эндпоинт будет
    viewImageUpload(data: Event): void {
        // this.selectedProductCardPhotos = [];
        // const target = data.target as HTMLInputElement;
        // const files = target.files;
        //
        // if (files) {
        //     for (let i = 0; i < files.length; i++) {
        //         const file = files[i];
        //         this.selectedProductCardPhotos.push(file);
        //         const reader = new FileReader();
        //
        //         reader.onload = (e: any) => {
        //             this.previews.push(e.target.result);
        //         };
        //
        //         reader.readAsDataURL(file);
        //     }
        // }
    }

    //TODO другой эндпоинт будет
    addNewPhotos(modal: NgbModalRef): void {
        // this.selectedProductCardPhotos.forEach(file => {
        //     this.productionService.addPhotoToProductCard(this.publicPuid, {photo: file}).subscribe({
        //         next: () => {
                    // if (modal) {
                    //     modal.close();
                    // }
                    // this.getCard();
                // }, error: error => {
                //     this.alertService.setAlert(error, 'blue');
                // },
            // });
        // });
    }

    //TODO другой эндпоинт будет
    removeImage(files: HTMLInputElement, i: number): void {
        // this.previews.splice(i, 1);
        //
        // let fileBuffer = Array.from(files.files);
        // fileBuffer.splice(i, 1);
        //
        // const dT = new ClipboardEvent('').clipboardData || new DataTransfer();
        //
        // for (let file of fileBuffer) {
        //     dT.items.add(file);
        // }
        // files.files = dT.files;
        // console.log(files.files, i);
    }

    //TODO другой эндпоинт будет (возможно)
    selectCollection(collection: NavigationTableResponseItemModel): void {
        // if (collection) {
        //     this.collectionId = collection.id;
        // }
    }

    //TODO другой эндпоинт будет (возможно)
    addCollection(modal: NgbModalRef): void {
        // this.productionService.addCollectionToProductCard(this.publicPuid, this.collectionId).subscribe({
        //     next: res => {
        //         modal.close();
        //         this.alertService.setAlert(res.message, 'green');
        //         this.getCard();
        //     }, error: () => {
        //         modal.close();
        //     },
        // });
    }

    onEventFind(event: NavigationTableRequestModel | PaginationModel): void {
        this.controller.loadNav(this.controller.prepare(event));
    }

    onEventClick(event: NavigationTableResponseItemModel, documentModal: TemplateRef<any>): void {
        this.documentKey = event.key;
        this.modalService.openTemplateModal(documentModal, 'xl');
    }

    openCollectionAccordion(collectionId: any): void {
        const request: NavigationTableRequestModel = new NavigationTableRequestModel();
        request.filter = 'collection';
        request.id = collectionId;
        request.limit = 5;
        this.controller.loadNav(this.controller.prepare(request));
    }

    //TODO другой эндпоинт будет (возможно)
    removeCollection(collectionId: number): void {
        // this.productionService.removeCollectionFromProductCard(collectionId, this.publicPuid).subscribe({
        //     next: () => {
        //         this.getCard();
        //     }, error: err => {
        //         this.alertService.setAlert(err.message, 'blue');
        //     }
        // });
    }
}
